<template>
    <div class="main">
        <div style="margin: 10px 16px;background-color: #fff;border-radius: 8px;padding: 1px 0;">
            <div class="div_card">
                <div>
                    <van-icon name="logistics" />
                    <a style="padding: 0 8px;">{{ form.Status }}</a>
                </div>
                <div v-if="form.DriverId" style="font-size: 14px;color: #999999;">接单时间：{{ form.DriverTime }}</div>
            </div>
            <div v-if="form.DriverId" class="div_card_diver">
                <div class="div_flex">
                    <div>送货司机：{{ form.Driver }}</div>
                    <div><a :href="'tel://' + form.DriverPhone" style="color: #fff;">{{ form.DriverPhone }}</a></div>
                </div>
                <div>收货时间：{{ form.DriverShipTime ? form.DriverShipTime : '-' }}</div>
                <div>送达时间：{{ form.DriverDeliveryTime ? form.DriverDeliveryTime : '-' }}</div>
            </div>
        </div>
        <div class="div_card" style="margin: 10px 16px;background-color: #fff;">
            <div style="display: flex;"><a class="div_icon" style="background-color: #333333;">发</a>发货人</div>
            <div style="text-align: right;">
                <div>{{ form.Name }}</div>
                <div>{{ form.Department }}</div>
                <div><a :href="'tel://' + form.Phone">手机：{{ form.Phone }}</a></div>
                <div><a :href="'tel://' + SponsorNum">座机：{{ form.Landline }}</a></div>
            </div>
        </div>
        <div style="border-radius: 8px;margin: 0 16px;background-color: #fff;">
            <div class="div_card">
                <div style="display: flex;"><a class="div_icon" style="background-color: #FEB013;">收</a>收货人</div>
                <div style="text-align: right;">
                    <div>{{ form.Receiver }}</div>
                    <div>{{ form.ReceiverDepartment }}</div>
                    <div><a :href="'tel://' + form.Phone">手机：{{ form.ReceiverPhone }}</a></div>
                    <div><a :href="'tel://' + ReceiverNum">座机：{{ form.ReceiverLandline }}</a></div>
                </div>
            </div>
            <div style="padding: 5px 16px;">
                <div class="div_flex" style="border-top: 1px #D2D2D2 solid;">
                    <div>发货地点</div>
                    <div>{{ form.DeliveryAddress }}</div>
                </div>
                <div class="div_flex">
                    <div>收货地点</div>
                    <div>{{ form.ShipAddress }}</div>
                </div>
                <div class="div_flex">
                    <div>送货时间</div>
                    <div>{{ form.DeliveryTime }}</div>
                </div> 
                <div class="div_flex">
                    <div>货物名称</div>
                    <div>{{ form.ItemName }}</div>
                </div>
                <div class="div_flex">
                    <div>数量</div>
                    <div>{{ form.ItemNum }}</div>
                </div>
                <div class="div_flex">
                    <div>单位</div>
                    <div>{{ form.ItemUnit }}</div>
                </div>
                <div class="div_flex">
                    <div>备注</div>
                    <div>{{ form.Remark }}</div>
                </div>
                <div class="div_flex" style="border-top: 1px #D2D2D2 solid;padding-top: 15px;">
                    <div>下单时间</div>
                    <div>{{ form.CreateTime }}</div>
                </div>
                <div class="div_flex" style="padding-bottom: 15px;">
                    <div>收货时间</div>
                    <div v-if="form.Status === '已签收'">{{ form.UpDateTime }}</div>
                </div>
            </div>
        </div>
        <div style="margin: 16px;">
            <van-button v-if="$route.query.role === 'sponsor' && ['待接单', '已接单'].includes(form.Status)" block round :disabled="btnStatus" color="#999" @click="onCancel">取消订单</van-button>
            <van-button v-if="$route.query.role === 'driver' && !form.DriverId" block round color="#333" :disabled="btnStatus" @click="onOrder">接单</van-button>
            <div v-if="$route.query.role === 'driver' && WXInfo.userid === form.DriverId && (form.Status === '已接单' || form.Status === '运送中')" class="div_flex">
                <van-button block round color="#FEB013" :disabled="form.DriverStatus !== '' || form.DriverStatus === '收货出发'" @click="onShip()">收货出发</van-button>
                <div style="width: 40px;"></div>
                <van-button block round color="#333" :disabled="form.DriverStatus === '' || form.DriverStatus === '已送达'" @click="onDelivery()">已送达</van-button>
            </div>
            <van-button v-if="$route.query.role === 'receiver' && form.Status === '运送中'" block round :disabled="btnStatus" color="#333" @click="onConfirm">确认收货</van-button>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            WXInfo: {},
            form: {},
            DriverList: [],
            btnStatus: false,
            SponsorNum: '',
            ReceiverNum: ''
        }
    },
    async mounted() {
        // const test = { "errno": 0, "data": { "errcode": 0, "errmsg": "ok", "userid": "2017551", "name": "吴昌悦", "department": [2267], "position": "软件开发工程师", "mobile": "15812615614", "gender": "1", "email": "wuchangyue@jianlianmed.com", "avatar": "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0", "status": 1, "isleader": 0, "extattr": { "attrs": [{ "name": "英文名", "value": "", "type": 0, "text": { "value": "" } }, { "name": "工号", "value": "2017551", "type": 0, "text": { "value": "2017551" } }, { "name": "身份证", "value": "", "type": 0, "text": { "value": "" } }] }, "english_name": "", "telephone": "020-88985632", "enable": 1, "hide_mobile": 0, "order": [0], "external_profile": { "external_attr": [], "external_corp_name": "" }, "main_department": 2267, "qr_code": "https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c", "alias": "", "is_leader_in_dept": [0], "address": "", "thumb_avatar": "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100", "direct_leader": [], "openid": "o_Td1s7gCLuLiZITNxC3ApjOLC7U", "access_token": "hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w" } }
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data

        this.getDataById()
    },
    methods: {
        sendMessage(type, userid) {
            let Message = ''
            if (type === '接单通知收货人') {
                Message = '收货任务通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n发货人：' + this.form.Name +
                    '\n发货地点：' + this.form.DeliveryAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n\n您收到一个收货任务，请及时处理。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?id='+ this.form._id +'">查看详情</a>'
            } else if (type === '接单通知发货人') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n收货人：' + this.form.Receiver +
                    '\n收货地点：' + this.form.ShipAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n司机：' + this.WXInfo.name +
                    '\n\n您发起的转货任务已被司机接单。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?role=sponsor&id='+ this.form._id +'">查看详情</a>'
            } else if (type === '司机出发通知发货人') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n收货人：' + this.form.Receiver +
                    '\n收货地点：' + this.form.ShipAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n司机：' + this.form.Driver +
                    '\n\n您需要转货的物品，司机已装运出发了，请注意查看货物情况。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?role=sponsor&id='+ this.form._id +'">查看详情</a>'
            } else if (type === '取消订单') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n\n该转货任务已被发起人取消。'
            } else if (type === '已送达通知收货人') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n收货人：' + this.form.Receiver +
                    '\n收货地点：' + this.form.ShipAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n司机：' + this.form.Driver +
                    '\n\n您需要转货的物品，司机已送达，请前往确认。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?role=receiver&id='+ this.form._id +'">查看详情</a>'
            }
            // console.log('userid', userid)
            this.postSendMessage(userid, Message)
        },
        async onOrder() {
            console.log('司机接单')
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    DriverId: this.WXInfo.userid,
                    Driver: this.WXInfo.name,
                    DriverPhone: this.WXInfo.mobile,
                    DriverTime: this.$moment().format('YYYY-MM-DD HH:mm'),
                    Status: '已接单',
                    DriverStatus: ''
                }
            })
            if (result.success) {
                this.$toast('提交成功')
                this.sendMessage('接单通知收货人', this.form.ReceiverId)
                this.sendMessage('接单通知发货人', this.form.UserId)
                this.getDataById()
            } else {
                this.$toast(result.message)
            }
        },
        async onShip() {
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    DriverStatus: '收货出发',
                    Status: '运送中',
                    DriverShipTime: this.$moment().format('YYYY-MM-DD HH:mm')
                }
            })
            if (result.success) {
                this.$toast('提交成功')
                this.sendMessage('司机出发通知发货人', this.form.UserId)
                this.getDataById()
            } else {
                this.$toast(result.message)
            }
        },
        async onDelivery() {
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    DriverStatus: '已送达',
                    DriverDeliveryTime: this.$moment().format('YYYY-MM-DD HH:mm')
                }
            })
            if (result.success) {
                this.$toast('提交成功')
                this.sendMessage('已送达通知收货人', this.form.ReceiverId)
                this.getDataById()
            } else {
                this.$toast(result.message)
            }
        },
        async onConfirm() {
            console.log('确认收货')
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    Status: '已签收'
                }
            })
            if (result.success) {
                this.$toast('提交成功')
                this.getDataById()
            } else {
                this.$toast(result.message)
            }
        },
        async onCancel() {
            console.log('取消订单')
            const result = await this.$request({
                url: '/api/GeneralMethod/deleteFunction',
                method: 'DELETE',
                params: {
                    Name: 'transport',
                    Condition: {
                        _id: this.$route.query.id,
                        UserId: this.form.UserId,
                        ReceiverId: this.form.ReceiverId,
                        Status: this.form.Status
                    }
                }
            })
            if (result.success) {
                if (this.form.Status === '已接单') {
                    this.sendMessage('取消订单', this.form.DriverId)
                } else {
                    // 获取车队人员列表
                    let userlist = await this.getQWUserList(3209)
                    userlist.forEach(item => {
                        this.sendMessage('取消订单', item.userid)
                    })
                }
                this.$router.push('/transport/index')
            } else {
                this.$toast(result.message)
            }
        },
        async getDataById() {
            const result = await this.$request({
                url: '/api/GeneralMethod/getFunctionById',
                method: 'GET',
                params: {
                    Id: this.$route.query.id,
                    Name: 'transport'
                }
            })
            if (result.data) {
                this.form = result.data
                this.SponsorNum = this.form.Landline.match(/\d+-\d+/) ? this.form.Landline.match(/\d+-\d+/)[0] : ''
                this.ReceiverNum = this.form.ReceiverLandline.match(/\d+-\d+/) ? this.form.ReceiverLandline.match(/\d+-\d+/)[0] : ''
            }
        },
        async getQWUserList(id) {
            const result = await this.$request({
                url: '/api/WXAuthorize/getDepartmentUserbyQW',
                method: 'GET',
                params: { id: id }
            })
            if (result.success) {
                return result.data
            } else {
                this.$toast(result.message)
            }
        },
        async postSendMessage(userid, message) {
            const result = await this.$request({
                url: this.$api.postSendMessageWX,
                method: 'POST',
                data: {
                    'touser': userid,
                    'msgtype': 'text',
                    'agentid': this.$agentid,
                    'text': { 'content': message }
                }
            })
            if (!result.success) {
                this.$toast(result.message)
            }
        }        
    }
}
</script>
  
<style lang="less" scoped>
.main {
    overflow: hidden;
}
.div_card {
    border-radius: 5px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.div_icon {
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
    border-radius: 50%;
    min-width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}
.div_flex { 
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
}
.div_card_diver {
    background-color: #3F97FC;
    color: #fff;
    border-radius: 12px;
    margin: 0 12px 12px 12px;
    padding: 12px;
    line-height: 1.5;
}
</style>
  